import { render, staticRenderFns } from "./SetupOverview.vue?vue&type=template&id=ef1c75d4&scoped=true"
import script from "./SetupOverview.vue?vue&type=script&lang=ts"
export * from "./SetupOverview.vue?vue&type=script&lang=ts"
import style0 from "./SetupOverview.vue?vue&type=style&index=0&id=ef1c75d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1c75d4",
  null
  
)

export default component.exports